// src/components/react-table/CellBoilerplate.tsx

import { Typography } from '@mui/material'

type Props = {
  value: any
}

export const CellBoilerplate = ({ value }: Props) => (
  <Typography sx={{ width: 100 }}>{value}</Typography>
)
